import {DroppableTextEditorRoot} from './components/root';
import {DroppableTextBox} from './components/droppable-text-box';
import {DraggableTag} from './components/draggable-tag';

export const DroppableTextEditor = Object.assign(DroppableTextEditorRoot, {
	TextBox: DroppableTextBox,
	DraggableTag: DraggableTag,
});